import { setOffersFetchingMode } from './setOffersFetchingMode';
import { toggleModal } from './toggleModal';
import { EListingModalMode, EOffersFetchingMode } from './types';
import { TThunkAction } from '../../types/redux';
import { resetListingOffers } from '../listingOffers/resetListingOffers';

export const closeMobileListing = (): TThunkAction => (dispatch, getState) => {
  if (!getState().listingModal.open) {
    return;
  }

  dispatch(toggleModal({ open: false, mode: EListingModalMode.UNSET }));
  dispatch(resetListingOffers());
  dispatch(setOffersFetchingMode(EOffersFetchingMode.NONE));
};
